export const color = {
  'brand-primary-700': '#3E24D6',
  'brand-primary-600': '#522CDF',
  'brand-primary-100': '#D3DAFC',
  'brand-primary-20': '#EDF0FE',
  'surface-error': '#FFEAED',
  'green-50': '#F0FFF6',
  'green-700': '#19A45A',
  'red-50': '#FFEAED',
  'red-700': '#EB3B47',
  'blue-50': '#F3F9FF',
  'blue-700': '#205BE0',
  'orange-50': '#FCF9F0',
  'orange-800': '#EC7100',
  'pink-50': '#fbe6f5',
  'pink-600': '#e545af',
  'pink-700': '#d40890',
  'pink-800': '#a4016e',
  'gray-50': '#FAFAFA',
  'success-600': '#20AB63',
  'text-primary': '#10222D',
  'text-secondary': '#405F7A',
  'text-tertiary': '#8D949E',
  'error-600': '#E32B2E',
  'info-600': '#5784ED',
  'surface-warning': '#FFECD4',
  'warning-900': '#8A3200',
  border: '#E4EBF2',
  white: '#FFF',
  black: '#000000'
};
